<button
  wlmCollapsibleButton
  [showLabel]="showLabel"
  [disabled]="disabled || isEmpty"
  [tooltip]="T_SCOPE + '.export-to-pdf'"
  (click)="exportToPdf()"
>
  <mat-icon class="material-icons-outlined" svgIcon="export-to-pdf"></mat-icon>
</button>
